import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Form, Loading } from 'components';

class PaymentForm extends Component {
  state = {
    data: this.props.data,
  };

  componentDidUpdate(oldProps, oldState) {
    const { data } = this.state;
    const { onChange } = this.props;

    if (oldProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }

    if (oldState.data !== data) {
      onChange(data);
    }
  }

  handleToggleScore = () => {
    const { data } = this.state;

    this.setState({ data: { ...data, score: !data.score } });
  };

  handleChangeInput = e => {
    const { value, name } = e.target;
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: value } });
  };

  handleToggle = name => {
    const { data } = this.state;

    this.setState({ data: { ...data, [name]: !data[name] } });
  };

  render() {
    const { data } = this.state;
    const { saving, onSubmit } = this.props;

    return (
      <Form className="page-form">
        <h3 className="form-title">Premiação</h3>

        <Form.Field>
          <Form.Label>Objetivo</Form.Label>
          <Form.Input name="goal" placeholder="Objetivo" value={data.goal} onChange={this.handleChangeInput} />
        </Form.Field>

        <Form.Field>
          <Form.Label>Recompensa</Form.Label>
          <Form.Input name="reward" placeholder="Recomponsa" value={data.reward} onChange={this.handleChangeInput} />
        </Form.Field>

        <Form.Field className="checkbox-field">
          <Form.Label>Ativo</Form.Label>
          <Form.Checkbox checked={data.active} onChange={() => this.handleToggle('active')} />
        </Form.Field>

        <div className="buttons">
          <Link to="/points/prizes" className="button-cancel">
            Cancelar
          </Link>

          <Form.Button className="button-save" onClick={onSubmit} disabled={saving}>
            {saving ? <Loading type="btn" size="small" text="Salvando..." /> : 'Salvar'}
          </Form.Button>
        </div>
      </Form>
    );
  }
}

export default PaymentForm;
